import AddCarrier from "../pages/carrier/addCarrier";
import CarrierIndex from "../pages/carrier/carrier";
import EditCarrier from "../pages/carrier/editCarrier";

const carrierRoutes = [
  {
    path: "carrier",
    element: <CarrierIndex />,
  },
  {
    path: "carrier/add",
    element: <AddCarrier />,
  },
  {
    path: "carrier/edit/:id",
    element: <EditCarrier />,
  },
];

export default carrierRoutes;